import { Box, Container } from '@mui/material';
import Hero from '../components/Hero';
import About from '../components/About';
import Features from '../components/Features';
import Vision from '../components/Vision';
import CountdownTimer from '../components/CountdownTimer';
import PreSaleBanner from '../components/PreSaleBanner';

const HomePage = () => {
  return (
    <>
      <Box sx={{
        pt: { xs: '64px', sm: '64px' }, // Account for AppBar height
        pb: 4
      }}>
        <Container maxWidth="lg" sx={{ 
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem'
        }}>
          <PreSaleBanner />
          <CountdownTimer />
          <Hero disableTopMargin />
        </Container>
      </Box>
      <About />
      <Features />
      <Vision />
    </>
  );
};

export default HomePage;
